(function ($) {
  Drupal.behaviors.offersHero = {
    attach: function (context) {
      var $detailsLink = $('.offers-hero__link', context);

      // Loop through each hero link
      $detailsLink.click(function (event) {
        event.preventDefault();
        var $this = $(this);
        var $offersHeroContainer = $this.parents('.offers-hero__container');
        var $description = $('.offers-hero__description', $offersHeroContainer);
        var $dropdown = $('.offers-hero__dropdown', $offersHeroContainer);
        var $content = $('.offers-hero__dropdown-content > div', $dropdown);
        var currentBreakpoint = Unison.fetch.now().name;

        if (currentBreakpoint === 'small') {
          $description.after($dropdown);
        }
        $dropdown.toggle();
        $this.attr('aria-expanded', $this.attr('aria-expanded') === 'true' ? 'false' : 'true');
        $content.matchHeight();
      });
    }
  };
})(jQuery);
